import { FC } from 'react'

import { useSuspenseQuery } from '@tanstack/react-query'

import { Cluster, Icon, Stack, Typography } from '@forto-dev/phoenix-ui-core/common'
import { Widget, WidgetFooter, WidgetHeader, WidgetTitle } from '@forto-dev/phoenix-ui-core/ship'

import { useLocalisation } from '@/utils/localisation'

import { entityDocumentsQueryOptions } from '../api/useEntityDocuments'

export type DocumentsSidebarProps = {
  id: string
  manualQuoteID?: string
  bookingID?: string
}

export const DocumentsSidebar: FC<DocumentsSidebarProps> = ({ id, manualQuoteID, bookingID }) => {
  const { translate } = useLocalisation()

  const documents = useSuspenseQuery(entityDocumentsQueryOptions(id, manualQuoteID, bookingID))
  const clusters = [
    {
      type: 'operations',
      items: documents.data.results.filter((document) => document.source === 'operations'),
    },
    {
      type: 'customer',
      items: documents.data.results.filter((document) => document.source === 'customer'),
    },
  ] as const

  return (
    <Stack gap={16}>
      <Widget variant="primary">
        <WidgetHeader>
          <WidgetTitle>{translate('documents.categories.all')}</WidgetTitle>
        </WidgetHeader>
        <WidgetFooter>
          <Cluster gap={4} y="center">
            <Icon size="md" name="Document" />
            <Typography variant="h3">{clusters.reduce((acc, cluster) => acc + cluster.items.length, 0)}</Typography>
          </Cluster>
        </WidgetFooter>
      </Widget>

      {clusters
        .filter((cluster) => cluster.items.length)
        .map((cluster) => {
          return (
            <Widget key={cluster.type} variant="neutral">
              <WidgetHeader>
                <WidgetTitle>{translate(`documents.categories.${cluster.type}`)}</WidgetTitle>
              </WidgetHeader>
              <WidgetFooter>
                <Cluster gap={4} y="center">
                  <Icon size="md" name="Document" />
                  <Typography variant="h3">{cluster.items.length}</Typography>
                </Cluster>
              </WidgetFooter>
            </Widget>
          )
        })}
    </Stack>
  )
}
